import React from "react";
import { Grid, Box } from "@mui/material";
import SideBarWithRouter from "./dashboard/sideBar";
import { ToastContainer } from "react-toastify";

function Dashboard(props) {
  return (
    <React.Fragment>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Box
        className="container"
        id="mainView"
        sx={{ 
          paddingTop: { xs: "16px", md: "24px" }, // Reduced from 60px to provide better spacing
          flex: "1", 
          display: "flex", 
          flexDirection: "column",
          px: { xs: 1, md: 2 }
        }}
      >
        <Grid container spacing={2} className="fill">
          <Grid item xs={0} sm={1} md={0} lg={2}>
            <SideBarWithRouter
              currentStorage={props.currentStorage}
              maxStorage={props.maxStorage}
              profileLoading={props.profileLoading}
              accountType={props.accountType}
            />
          </Grid>
          <Grid item md={12} lg={10} className="fill" id="contentArea">
            <Box sx={{ pr: { xs: 1, md: 3 } }}>
              {props.children}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
}

export default Dashboard;
